<form #form="ngForm">
    <div *ngIf="formulaireFactureService.paramFacture as paramFacture; else loading">
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.facture.parametrage'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="actif"
                            name="actif"
                            [ngModel]="paramFacture.actif"
                            [(customModel)]="paramFacture.actif"
                            customType="checkbox"
                            libelle="admin.parametres.formulaire.facture.actif"
                            postLibelle="admin.parametres.formulaire.facture.actifPost"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>
                <span [translate]="'admin.parametres.formulaire.facture.generalite'"></span>
            </mat-card-title>
            <mat-card-content>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="nbRepartitions"
                            name="nbRepartitions"
                            [(ngModel)]="paramFacture.nbRepartitions"
                            customType="number"
                            libelle="admin.parametres.formulaire.facture.nbRepartitions"
                            [postTooltip]="'admin.parametres.formulaire.facture.nbRepartitionsTooltip' | translate"
                            [min]="0"
                            [required]="true"
                    ></custom-input>
                </div>
                <div class="row">
                    <custom-input
                            ngDefaultControl
                            id="nbPeriodeOM"
                            name="nbPeriodeOM"
                            [(ngModel)]="paramFacture.nbPeriodeOM"
                            customType="number"
                            libelle="admin.parametres.formulaire.facture.nbPeriodeOM"
                            [postTooltip]="'admin.parametres.formulaire.facture.nbPeriodeOMToolTip' | translate"
                            [min]="0"
                            [required]="true"
                    ></custom-input>
                </div>
            </mat-card-content>
        </mat-card>
        <floating-button [listeActions]="listeActions" [isPending]="formulaireFactureService.isSaving"></floating-button>
    </div>
</form>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>
